import React from "react";
import "../JDS_Styles/main.scss";
import "../Styles/footer.css";
import { Divider, Footer, Text, TokenProvider } from "@jds/core";
import { IcJioDot } from "@jds/core-icons";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const FooterComponent = () => {
  const location = useLocation();
  const path = location.pathname;
  const portalTheme = useSelector((state) => state.common.portal_theme);
  const footerBg = portalTheme?.colors?.cardBackground
    ? undefined
    : "rgba(245, 245, 245, 1)";
  const footerStyle = {
    height: portalTheme?.privacyText ? "auto" : "55px",
    minHeight: "55px",
    backgroundColor: portalTheme?.colors?.cardBackground
      ? "var(--portal-header-bg, rgba(245, 245, 245, 1))"
      : footerBg,
    color: portalTheme?.colors?.cardFont || undefined,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingLeft: "3rem",
    paddingRight: "3rem",
    paddingTop: portalTheme?.privacyText ? "10px" : undefined,
    paddingBottom: portalTheme?.privacyText ? "10px" : undefined,
    gap: "12px",
    flexWrap: "wrap",
  };

  const openalert = () => {};

  // Hide footer on specific routes
  if (
    path === "/adminLogin" ||
    path === "/app-documents" ||
    path.startsWith("/home")
  ) {
    return null;
  }

  return (
    <TokenProvider
      value={{
        theme: "JioBase",
        mode: "light",
      }}
    >
      <div className="app-footer" style={footerStyle}>
        <div className="app-footer-brand">
          <IcJioDot height={25} width={25} color="primary" />
          <div>
            <Text color="primary-grey-80" appearance="body-xs">
              Copyright © 2025 Jio Platforms Limited. All rights reserved.
            </Text>
            {portalTheme?.privacyText ? (
              <Text
                color="primary-grey-80"
                appearance="body-xs"
                style={{ display: "block", marginTop: "4px" }}
              >
                {portalTheme.privacyText}
              </Text>
            ) : null}
          </div>
        </div>
        <div className="app-footer-links">
          <Text
            color="primary-grey-80"
            appearance="body-xs"
            style={{ cursor: "pointer" }}
          >
            Regulatory
          </Text>
          <div
            style={{
              backgroundColor: "rgba(224, 224, 224, 1)",
              height: "16px",
              width: "1px",
            }}
          ></div>

          <Text
            color="primary-grey-80"
            appearance="body-xs"
            style={{ cursor: "pointer" }}
          >
            Policies
          </Text>
          <div
            style={{
              backgroundColor: "rgba(224, 224, 224, 1)",
              height: "16px",
              width: "1px",
            }}
          ></div>
          <Text
            color="primary-grey-80"
            appearance="body-xs"
            style={{ cursor: "pointer" }}
          >
            Terms & Conditions
          </Text>
          <div
            style={{
              backgroundColor: "rgba(224, 224, 224, 1)",
              height: "16px",
              width: "1px",
            }}
          ></div>
          <div onClick={openalert} style={{ cursor: "pointer" }}>
            <Text color="primary-grey-80" appearance="body-xs">
              Help & Support
            </Text>
          </div>
        </div>
      </div>
    </TokenProvider>
  );
};

export default FooterComponent;
